"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var BaseModule_1 = require("./BaseModule");
/**
 * Display the pixel width&height of an image
 *
 * @export
 * @class DisplaySize
 * @extends {BaseModule}
 */
var DisplaySize = /** @class */ (function (_super) {
    __extends(DisplaySize, _super);
    function DisplaySize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisplaySize.prototype.onCreate = function () {
        this.display = document.createElement('div');
        lodash_1.assign(this.display.style, this.options.displayStyles);
        this.overlay.appendChild(this.display);
    };
    DisplaySize.prototype.onDestroy = function () {
    };
    DisplaySize.prototype.onUpdate = function () {
        if (!this.display || !this.img)
            return;
        var size = this.getCurrentSize();
        this.display.innerHTML = size.join(' &times; ');
        if (size[0] > 120 && size[1] > 30) {
            // Position - top of image
            this.display.style.right = '4px';
            this.display.style.bottom = '4px';
            this.display.style.left = 'auto';
        }
        else if (this.img.style['float'] === 'right') {
            // Position - bottom left
            var bounds = this.display.getBoundingClientRect();
            this.display.style.right = 'auto';
            this.display.style.bottom = (bounds.height + 4) + 'px';
            this.display.style.left = (bounds.width + 4) + 'px';
        }
        else {
            // Position - bottom right
            var bounds = this.display.getBoundingClientRect();
            this.display.style.right = (bounds.width + 4) + 'px';
            this.display.style.bottom = (bounds.height + 4) + 'px';
            this.display.style.left = 'auto';
        }
    };
    DisplaySize.prototype.getCurrentSize = function () {
        return [
            this.img.width,
            Math.round((this.img.width / this.img.naturalWidth) * this.img.naturalHeight)
        ];
    };
    return DisplaySize;
}(BaseModule_1.BaseModule));
exports.DisplaySize = DisplaySize;
//# sourceMappingURL=DisplaySize.js.map